"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _operationsConfig = require("@/api/community/operationsConfig");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MallSettings',
  data: function data() {
    return {
      form: {
        recommendations: [{
          images: [],
          path: '/pages/shop/cards/index'
        }, {
          images: [],
          path: '/pages/shop/cards/index'
        }],
        blessings: "\u613F\u6240\u6709\u7F8E\u597D\u5982\u671F\u800C\u81F3\n\u5F80\u540E\u4F59\u751F,\u4E0D\u8D1F\u6D41\u5E74,\u5E73\u5B89\u559C\u4E50!\n\u613F\u4F60\u591A\u4E9B\u5E78\u8FD0\n\u613F\u6709\u4EBA\u6210\u4E3A\u4F60\u7684\u76D6\u4E16\u82F1\u96C4\n\u5143\u6C14\u6EE1\u6EE1,\u8377\u5305\u6EE1\u6EE1,\u5F00\u5FC3\u6EE1\u6EE1!"
      },
      dialogVisible: false,
      dialogImageUrl: ''
    };
  },
  created: function created() {
    this.loadConfig();
  },
  methods: {
    loadConfig: function loadConfig() {
      var _this = this;
      (0, _operationsConfig.getConfigById)(1004).then(function (res) {
        if (res.data && res.data.value) {
          try {
            var config = JSON.parse(res.data.value);
            if (config.recommendations) {
              _this.form.recommendations = config.recommendations.map(function (item) {
                if (item.images && item.images.length && item.images[0].path) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    images: [{
                      url: (0, _operationsConfig.getImageUrl)(item.images[0].path),
                      name: item.images[0].name || 'image.jpg',
                      path: item.images[0].path
                    }]
                  });
                }
                return item;
              });
            }
            if (config.blessings) _this.form.blessings = config.blessings;
          } catch (e) {/* 忽略 */}
        }
      });
    },
    onReset: function onReset() {
      this.$refs.opsForm.resetFields();
      this.form.recommendations = [{
        images: [],
        path: '/pages/shop/cards/index'
      }, {
        images: [],
        path: '/pages/shop/cards/index'
      }];
      this.form.blessings = "\u613F\u6240\u6709\u7F8E\u597D\u5982\u671F\u800C\u81F3\n\u5F80\u540E\u4F59\u751F,\u4E0D\u8D1F\u6D41\u5E74,\u5E73\u5B89\u559C\u4E50!\n\u613F\u4F60\u591A\u4E9B\u5E78\u8FD0\n\u613F\u6709\u4EBA\u6210\u4E3A\u4F60\u7684\u76D6\u4E16\u82F1\u96C4\n\u5143\u6C14\u6EE1\u6EE1,\u8377\u5305\u6EE1\u6EE1,\u5F00\u5FC3\u6EE1\u6EE1!";
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      var payload = {
        recommendations: this.form.recommendations.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            images: item.images && item.images.length && item.images[0].path ? [{
              path: item.images[0].path
            }] : []
          });
        }),
        blessings: this.form.blessings
      };
      (0, _operationsConfig.updateConfig)(1004, JSON.stringify(payload)).then(function () {
        _this2.$message.success('已保存商城设置');
        _this2.loadConfig();
      });
    },
    addRecommendation: function addRecommendation() {
      this.form.recommendations.push({
        images: [],
        path: ''
      });
    },
    removeRecommendation: function removeRecommendation(index) {
      var _this3 = this;
      if (this.form.recommendations.length <= 1) {
        this.$message.warning('至少需要保留一项推荐');
        return;
      }
      this.$confirm('确定要删除此项推荐吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.form.recommendations.splice(index, 1);
        _this3.$message.success('已删除推荐项');
      }).catch(function () {
        // 用户取消删除
      });
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove: function handleRemove(file, fileList, index) {
      this.form.recommendations[index].images = [];
    },
    handleImageChange: function handleImageChange(file, fileList, index) {
      this.form.recommendations[index].images = fileList;
    },
    // 触发文件输入（自定义上传）
    triggerFileInput: function triggerFileInput(index) {
      this.$refs["fileInput".concat(index)][0].click();
    },
    // 处理文件选择（自定义上传）- 立即上传
    handleFileChange: function handleFileChange(event, index) {
      var _this4 = this;
      var file = event.target.files[0];
      if (!file) return;
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return;
      }
      (0, _operationsConfig.uploadImage)(file, '/').then(function (res) {
        var fileObj = {
          name: file.name,
          url: (0, _operationsConfig.getImageUrl)(res.data),
          path: res.data
        };
        _this4.form.recommendations[index].images = [fileObj];
      });

      // 允许重复选择同一文件
      event.target.value = '';
    },
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
      return true;
    }
  }
};